import {BitacoraModel} from "@/models/bitacoras/bitacora";
import * as R from "ramda";

function evaluateModelChangedFlag(data){
  if(!data && typeof data === "boolean"){
  return data
  }

  if(data && typeof data === "object"){
  return data.length>=1;
  } 
}
const modelIsModified = R.curry((mod)=>R.compose(evaluateModelChangedFlag,mod.changed)());

//Base State
function BaseStateForm(){}
// States' consctructors
export function InitialState(self){
  //Assing context
  this.data = self;
  //Reset Models and validators
  this.resetModel();
  this.resetValidators();
  //View configuration
  this.data.view.elem.button.submit.text="Buscar";

}

export function SavedState(self, {usuario_username,fecha_inicio,fecha_fin}){}
// Setting Base as prototype
InitialState.prototype = Object.create(BaseStateForm.prototype);
// Setting his own constructor instead of constructor's prototype
InitialState.prototype.constructor = InitialState;
//Base skeleton
BaseStateForm.prototype.submit = function(){console.log("submit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.resetModel = function(){this.data.bitacora = new BitacoraModel();}
BaseStateForm.prototype.resetValidators = function(){this.data.$v.$reset();}



// WEBPACK FOOTER //
// ./src/views/bitacoras/bitacora/bitacora-states.js